import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function EmailValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const emailRegExp = /^([a-z0-9_\.-])+@[a-z0-9-]+\.([a-z]{2,10}\.)?[a-z]{2,10}$/i;
    const isValid = emailRegExp.test(control.value);
    return isValid ? null : { email: true };
  };
}
